/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import { FC, memo, useState } from 'react'
import { Form, Formik, FormikProps } from 'formik'
import { Trans } from 'react-i18next'
import * as Analytics from 'core/common/analytics'
import i18n from 'core/common/i18n'
import CardStep from 'core/components/CardStep'
import { Button } from 'core/components/Core'
// eslint-disable-next-line no-unused-vars
import { useFormContext } from 'core/pages/ProductNew-v2/context/ProductNewContext'
import { BULK_FIELD_NAME } from '../constants'
import { TFormValues, TVariationValueProps } from '../types'
import BulkModeButton from './BulkModeButton'
import { getValidationSchemaByFieldNames } from './helpers'
import VariationField from './VariationField'

const VariationValue: FC<TVariationValueProps> = ({
  variationType,
  onSubmit,
  showBulkMode = false,
  fields,
  onChange,
  handleEditStep,
  formMode,
}) => {
  const [isBulkMode, setBulkMode] = useState<boolean>(false)
  const isSingleField = !fields.length || isBulkMode

  const initialValues = isSingleField
    ? { [BULK_FIELD_NAME]: [] }
    : Object.fromEntries(fields.map(({ name, values }) => [name, values]))

  const validationSchema = getValidationSchemaByFieldNames(
    isSingleField ? [{ name: BULK_FIELD_NAME }] : fields
  )

  const toggleBulkMode = () => {
    setBulkMode(prevBulkMode => !prevBulkMode)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleValidation = async ({ validateForm }: Pick<FormikProps<any>, 'validateForm'>) => {
    const errors = await validateForm()

    if (Object.keys(errors).length) {
      Analytics.ProductVariationAttributeValidationError(
        formMode,
        i18n.t(`multivariation.types.${variationType}`)
      )
    }
  }

  const renderFields = ({ setFieldValue, errors, touched, values }: FormikProps<TFormValues>) => {
    if (isSingleField) {
      return (
        <VariationField
          variationType={variationType}
          variations={fields.length ? fields.map(field => field.variations) : []}
          setFieldValue={newValue => setFieldValue(BULK_FIELD_NAME, newValue)}
          value={values[BULK_FIELD_NAME]}
          error={touched[BULK_FIELD_NAME] && (errors[BULK_FIELD_NAME] as string | undefined)}
          onChange={onChange}
        />
      )
    }

    return fields.map(({ name, variations }) => {
      return (
        <VariationField
          key={name}
          variationType={variationType}
          variations={variations}
          setFieldValue={newValue => setFieldValue(name, newValue)}
          value={values[name]}
          error={touched[name] && (errors[name] as string | undefined)}
          onChange={onChange}
        />
      )
    })
  }

  return (
    <Formik
      key={isBulkMode ? 'bulkMode' : 'multiMode'}
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {formikProps => {
        return (
          <Form>
            <CardStep
              title={
                <Trans
                  i18nKey="multivariation.variationValue.title"
                  t={i18n.t}
                  values={{ type: i18n.t(`multivariation.types.${variationType}`).toLowerCase() }}
                />
              }
              headerAction={
                <BulkModeButton
                  isBulkMode={isBulkMode}
                  show={fields.length > 1 && showBulkMode}
                  onClick={toggleBulkMode}
                />
              }
              footerActions={
                <>
                  <Button
                    variant="text"
                    color="primary"
                    onClick={() => {
                      formikProps.resetForm()
                      handleEditStep(null)
                    }}
                    className="mr-2"
                  >
                    <span>Cancelar</span>
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => {
                      formikProps.handleSubmit()
                      handleValidation({ validateForm: formikProps.validateForm })
                    }}
                  >
                    {i18n.t('general.confirm')}
                  </Button>
                </>
              }
            >
              {renderFields(formikProps)}
            </CardStep>
          </Form>
        )
      }}
    </Formik>
  )
}

export default memo(VariationValue)
